import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PropertySearchCardVM } from '../../models/property-search-card.vm';

/**
 * Sección de resultados de búsqueda. Presentacional: recibe los resultados
 * y los flags de estado desde el contenedor (facade) y resuelve qué mostrar:
 * error, loading (skeletons), vacío o el grid de cards. Sin services.
 */
@Component({
    selector: 'app-property-search-list',
    templateUrl: './property-search-list.component.html',
    styleUrls: ['./property-search-list.component.scss'],
})
export class PropertySearchListComponent {
    @Input() results: PropertySearchCardVM[] | null = [];
    @Input() loading: boolean | null = false;
    @Input() error: string | null = null;
    @Output() retry = new EventEmitter<void>();

    /** Placeholders del estado de carga. */
    readonly skeletons = Array.from({ length: 8 });
}
